import {
  IStaffPayout,
  PAY_PERIOD,
  PAYMENT_METHOD,
  PAYOUT_STATUS,
} from '../../apis/staff/staffPayout.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockDocument } from '../documents/documentMock';
import { GENDER } from 'src/apis/users/users.interfaces';

export const mockStaffPayoutList: IStaffPayout[] = [
  {
    payoutId: 'PAY001',
    user: {
      firstName: 'John',
      lastName: 'Doe',
      gender: GENDER.MALE,
    },
    amount: 50000,
    month: 'March',
    year: 2024,
    status: PAYOUT_STATUS.PAID,
    salaryBreakdown: {
      basic: 50000,
      hra: 10000,
      da: 5000,
      transportAllowance: 1000,
      medicalAllowance: 500,
      specialAllowance: 1000,
      otherAllowances: 1000,
      grossSalary: 50000,
      totalDeductions: 10000,
      netSalary: 40000,
    },
    financialYear: '2024-25',
    payPeriod: PAY_PERIOD.FULL_MONTH,
    payslip: mockDocument,
    actions: {
      created: mockUserAction,
    },
    remarks: 'Payment successful',
    processedBy: 'John Doe',
    processedOn: '2024-03-01',
    approvedBy: 'Jane Doe',
    approvedOn: '2024-03-01',
    paymentDate: '2024-03-01',
  },
  {
    payoutId: 'PAY002',
    user: {
      firstName: 'Jane',
      lastName: 'Doe',
      gender: GENDER.FEMALE,
    },
    amount: 45000,
    month: 'March',
    year: 2024,
    status: PAYOUT_STATUS.PENDING,
    salaryBreakdown: {
      basic: 45000,
      hra: 9000,
      da: 4500,
      transportAllowance: 900,
      medicalAllowance: 450,
      specialAllowance: 900,
      otherAllowances: 900,
      grossSalary: 45000,
      totalDeductions: 9000,
      netSalary: 36000,
    },
    financialYear: '2024-25',
    payPeriod: PAY_PERIOD.FULL_MONTH,
    payslip: mockDocument,
    actions: {
      created: mockUserAction,
    },
    approvedBy: 'Jane Doe',
    remarks: 'Payment successful',
  },
  {
    payoutId: 'PAY003',
    user: {
      firstName: 'Jim',
      lastName: 'Beam',
      gender: GENDER.MALE,
    },
    amount: 48000,
    month: 'March',
    year: 2024,
    status: PAYOUT_STATUS.PROCESSING,
    paymentMethod: PAYMENT_METHOD.NEFT,
    paymentDate: '2024-03-01',
    transactionReference: '1234567890',
    bankDetails: {
      accountNumber: '1234567890',
      ifscCode: '1234567890',
      bankName: 'Bank of America',
      branchName: 'New York',
    },
    taxDetails: {
      pan: '1234567890',
      uan: '1234567890',
      tdsAmount: 1000,
      taxSlab: '10%',
    },
    salaryBreakdown: {
      basic: 48000,
      hra: 9600,
      da: 4800,
      transportAllowance: 960,
      medicalAllowance: 480,
      specialAllowance: 960,
      otherAllowances: 960,
      grossSalary: 48000,
      totalDeductions: 9600,
      netSalary: 38400,
    },
    financialYear: '2024-25',
    payPeriod: PAY_PERIOD.FULL_MONTH,
    payslip: mockDocument,
    actions: {
      created: mockUserAction,
    },
    processedBy: 'John Doe',
    processedOn: '2024-03-01',
    approvedBy: 'Jane Doe',
    approvedOn: '2024-03-01',
    remarks: 'Payment successful',
  },
  {
    payoutId: 'PAY004',
    user: {
      firstName: 'Jill',
      lastName: 'Smith',
      gender: GENDER.FEMALE,
    },
    amount: 52000,
    month: 'March',
    year: 2024,
    status: PAYOUT_STATUS.FAILED,
    paymentMethod: PAYMENT_METHOD.NEFT,
    paymentDate: '2024-03-01',
    transactionReference: '1234567890',
    bankDetails: {
      accountNumber: '1234567890',
      ifscCode: '1234567890',
      bankName: 'Bank of America',
      branchName: 'New York',
    },
    taxDetails: {
      pan: '1234567890',
      uan: '1234567890',
      tdsAmount: 1000,
      taxSlab: '10%',
    },
    processedBy: 'John Doe',
    processedOn: '2024-03-01',
    approvedBy: 'Jane Doe',
    approvedOn: '2024-03-01',
    remarks: 'Payment successful',
    salaryBreakdown: {
      basic: 52000,
      hra: 10400,
      da: 5200,
      transportAllowance: 1040,
      medicalAllowance: 520,
      specialAllowance: 1040,
      otherAllowances: 1040,
      grossSalary: 52000,
      totalDeductions: 10400,
      netSalary: 41600,
    },
    financialYear: '2024-25',
    payPeriod: PAY_PERIOD.FULL_MONTH,
    payslip: mockDocument,
    actions: {
      created: mockUserAction,
    },
  },
  {
    payoutId: 'PAY005',
    user: {
      firstName: 'John',
      lastName: 'Doe',
      gender: GENDER.MALE,
    },
    amount: 50000,
    month: 'March',
    year: 2024,
    status: PAYOUT_STATUS.PAID,
    paymentMethod: PAYMENT_METHOD.NEFT,
    paymentDate: '2024-03-01',
    transactionReference: '1234567890',
    bankDetails: {
      accountNumber: '1234567890',
      ifscCode: '1234567890',
      bankName: 'Bank of America',
      branchName: 'New York',
    },
    taxDetails: {
      pan: '1234567890',
      uan: '1234567890',
      tdsAmount: 1000,
      taxSlab: '10%',
    },
    processedBy: 'John Doe',
    processedOn: '2024-03-01',
    approvedBy: 'Jane Doe',
    approvedOn: '2024-03-01',
    remarks: 'Payment successful',
    salaryBreakdown: {
      basic: 50000,
      hra: 10000,
      da: 5000,
      transportAllowance: 1000,
      medicalAllowance: 500,
      specialAllowance: 1000,
      otherAllowances: 1000,
      grossSalary: 50000,
      totalDeductions: 10000,
      netSalary: 40000,
    },
    financialYear: '2024-25',
    payPeriod: PAY_PERIOD.FULL_MONTH,
    payslip: mockDocument,
    actions: {
      created: mockUserAction,
    },
  },
];
